<template>
  <button type="button" :class="className" @click="openCart">
    <slot>Allocation</slot>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'

withDefaults(defineProps<{
  className?: string
}>(), {
  className: ''
})

const cartStore = ref<any>(null)

const ensureCart = async () => {
  if (cartStore.value) return cartStore.value
  const { useCartStore } = await import('~/stores/cart')
  cartStore.value = useCartStore()
  return cartStore.value
}

const openCart = async () => {
  const store = await ensureCart()
  if (!store.isOpen) {
    store.toggleCart()
  }
}
</script>
